import { BasePrompt, IBasePromptOptions } from './base-prompt'
import { ControlTypes } from '../'

export interface IRichTextareaPromptOptions extends IBasePromptOptions<string> {
  height: number
  menubar: string
  toolbar: string | boolean
  placeholderText: string
}

export class RichTextareaPrompt extends BasePrompt<string> {
  public controlType = ControlTypes.RichTextarea
  public height: number
  public menubar: string
  public toolbar: string | boolean
  public placeholderText: string

  constructor(options: IRichTextareaPromptOptions = { height: 0, menubar: undefined, toolbar: undefined, placeholderText: '' }) {
    super(options)
    this.height = options.height
    this.menubar = options.menubar
    this.toolbar = options.toolbar
    this.placeholderText = options.placeholderText || ''
  }
}



// WEBPACK FOOTER //
// ./node_modules/@mprep/shared/lib/forms/models/prompt/rich-textarea-prompt.ts